import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogCommonComponent } from './dialog-common.component';
import { SharedModules } from 'src/app/shared.modules';

@NgModule({
  declarations: [DialogCommonComponent],
  exports: [DialogCommonComponent],
  imports: [
    CommonModule,
    SharedModules
  ]
})
export class DialogCommonModule { }
